export default __webpack_public_path__ + "static/media/np.2cd8ed52.png";